import { render, staticRenderFns } from "./PaymentsForUser.vue?vue&type=template&id=c1c4f23e&"
import script from "./PaymentsForUser.vue?vue&type=script&lang=js&"
export * from "./PaymentsForUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports